/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react'
import { Field } from 'formik'
import { FormLabel, FormText } from 'react-bootstrap'
import { ATInputProps } from './FormComponentProps'

const ATInput: React.FC<ATInputProps> = ({
  name,
  label,
  onChangeHandler,
  onBlurHandler,
  value = '',
  isError,
  error,
  placeholder,
  disabled = false,
  type = 'input',
  isMultiLine = false,
  isMandatory = true,
  rightIcon,
}) => {
  return (
    <div>
      <FormLabel className="text-start w-100 pt-2 form-label-text">
        <span>{label}</span>
        {isMandatory && <span className="text-danger">*</span>}
      </FormLabel>
      <div className="position-relative">
        <Field
          as={isMultiLine ? 'textarea' : ''}
          disabled={disabled}
          name={name}
          placeholder={placeholder}
          aria-label={label}
          className={`form-control app-input ${
            isMultiLine ? 'direction-input' : ''
          } ${rightIcon ? 'pe-5' : ''}`}
          type={type}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={value}
        />
        {rightIcon && (
          <span
            className="position-absolute"
            style={{
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
          >
            {rightIcon}
          </span>
        )}
      </div>
      <FormText className="text-danger">{isError && <>{error}</>}</FormText>
    </div>
  )
}

export default ATInput
